module.exports = __webpack_public_path__ + "img/recommed-img10.893dfa5d.jpg";